import { useEffect, useRef } from "react";
import Tooltip from "bootstrap/js/dist/tooltip";
import { InfoIcon } from "lucide-react";

export default function InfoTooltip({ content, placement = "right" }) {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const tooltip = new Tooltip(tooltipRef.current, {
      title: content,
      placement,
      trigger: "hover focus",
      container: "body",
    });

    return () => tooltip.dispose();
  }, [content, placement]);

  return (
    <span
      ref={tooltipRef}
      className="ms-1 text-muted cursor-pointer d-inline-flex align-items-center position-relative top-0.5"
      role="button"
      tabIndex="0"
    >
      <InfoIcon className="ms-0" size={14} />
    </span>
  );
}
